export const styles = {
  container:
    'flex-1 flex flex-col px-4 py-6 max-h-[calc(100vh-9rem)] max-h-[calc(100svh-9rem)] overflow-y-auto',
  filtersContainer: 'flex justify-between items-center mb-6',
  filterButton:
    'inline-flex items-center border border-gray-300 bg-white text-gray-800 rounded-lg px-4 py-2.5 text-sm font-medium hover:bg-gray-50 hover:border-gray-400 transition-all duration-150 shadow-sm',
  // Cards (adicionados para alinhar com previous closings)
  cardsContainer: 'space-y-3',
  card: 'bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden',
  cardHeader:
    'bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100',
  cardDate: 'text-sm font-semibold text-gray-900',
  cardTime: 'text-xs text-gray-500 mt-1',
  cardBody: 'p-4',
  cardRow: 'flex justify-between items-center py-2',
  cardLabel: 'text-sm font-medium text-gray-600',
  cardAmount: 'text-lg font-bold text-green-600',
  cardValue: 'text-sm font-semibold text-gray-900',
  cardActions: 'flex justify-end pt-3 border-t border-gray-100',

  tableContainer:
    'flex-1 bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm',
  table: 'w-full table-fixed border-collapse',
  tableHeader: 'bg-gray-50',
  headerRow: '',
  headerCell:
    'px-3 py-4 text-sm font-semibold text-gray-700 border border-gray-300 uppercase tracking-wide text-center bg-gray-50',
  colSale: 'w-[18%]',
  colStatus: 'w-[20%]',
  colAmount: 'w-[20%]',
  colTime: 'w-[16%]',
  colActions: 'w-[26%]',
  tableBody: '',
  tableRow: 'hover:bg-gray-50 transition-colors duration-150',
  cell: 'px-3 py-4 text-sm text-gray-900 border border-gray-300 text-center overflow-hidden',

  // Status badges (usar cores padrão Tailwind para garantir compilação)
  statusAwaitingPayment:
    'bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide inline-block max-w-full truncate',
  statusSettled:
    'bg-green-100 text-green-800 px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide inline-block max-w-full truncate',
  statusCanceledRefund:
    'bg-red-100 text-red-800 px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide inline-block max-w-full truncate',
  statusExpired:
    'bg-gray-200 text-gray-800 px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide inline-block max-w-full truncate',
  statusError:
    'bg-red-100 text-red-800 px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide inline-block max-w-full truncate',
  actionIconButton:
    'flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300',

  // Estado vazio (reutilizado)
  emptyState:
    'flex flex-col items-center justify-center py-8 px-6 text-center bg-white rounded-xl border border-gray-200 shadow-sm',
  emptyStateIcon: 'mb-4',
  emptyStateTitle: 'text-lg font-semibold text-gray-700 mb-2',
  emptyStateMessage: 'text-gray-500 mb-6 max-w-sm leading-relaxed text-sm',
  emptyStateActions: 'flex flex-col gap-2 w-full max-w-xs',
  emptyStateButton:
    'flex items-center justify-center bg-blue-600 text-white px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-700 transition-all duration-150 shadow-sm hover:shadow-md',
  emptyStateButtonSecondary:
    'flex items-center justify-center bg-gray-100 text-gray-700 px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-200 transition-all duration-150 shadow-sm hover:shadow-md',

  // Paginação (necessária para botões usados)
  paginationContainer:
    'bg-white rounded-xl border border-gray-200 shadow-sm p-4 mt-4',
  paginationControls: 'flex items-center justify-center space-x-2',
  paginationButton:
    'px-3 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed',
  paginationButtonActive:
    'px-3 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white border border-blue-600',
  paginationButtonIcon: 'w-4 h-4',

  actionsContainer: 'flex flex-col sm:flex-row gap-4 mt-8 w-full',
  actionButton:
    'h-16 w-full bg-black text-white rounded-xl text-center hover:bg-gray-900 transition-all duration-150 text-base font-semibold shadow-md hover:shadow-lg flex items-center justify-center tracking-wide',
  printButton:
    'w-full h-[55px] text-white rounded-lg text-center hover:bg-gray-900 transition-all duration-150 text-sm font-semibold shadow-lg hover:shadow-xl text-xl font-semibold',
  backButton:
    'w-full h-[55px] text-white rounded-lg text-center hover:bg-gray-900 transition-all duration-150 text-sm font-semibold shadow-lg hover:shadow-xl text-xl font-semibold',
} as const

export const texts = {
  title: 'Ventas del día',
  filter: 'Filtrar',
  sort: 'Classificar',
  sale: 'Venta',
  status: 'Status',
  amount: 'Monto',
  time: 'Hora',
  actions: 'Acciones',
  print: 'Imprimir',
  goBack: 'Regresar',
  noRecord: '¡Ningún registro encontrado!',
  tryAgain: 'Ajusta los filtros o inténtalo de nuevo.',
  updateFilter: 'Actualizar',
  items: 'Ítems',
} as const
